export interface Header {
  height: number;
}

const header: Header = {
  height: 6,
};

export default header;
